import React from "react";
import { ReactNavbar } from "overlay-navbar";
import logo from "../../icons/logo-2.jpg";
import { FaUserAlt } from "react-icons/fa";
const Header = () => {
	return (
		<ReactNavbar
			navColor1="white"
			navColor2="black"
			burgerColor="#46a5fc"
			logoWidth="150px"
			logoHeigth="150px"
			logoBorderRadius="10px"
			logo={logo}
			logoHoverColor="red"
			nav3justifyContent="space-around"
			nav2justifyContent="space-around"
			link1Text="Home"
			link2Text="About"
			link3Text="Projects"
			link4Text="Contact"
			link1Url="/"
			link2Url="/about"
			link3Url="projects"
			link4Url="/contact"
			link1ColorHover="HSL(60, 100%, 50%)"
			link1Color="white"
			link1Size="1.5rem"
			link1Padding="3vmax"
			profileIcon={true}
			ProfileIconElement={FaUserAlt}
			profileIconColorHover="HSL(60, 100%, 50%)"
		/>
	);
};

export default Header;
